/**
 * Volume
 *
 * Bar chart of raw trading volume.
 * Bars are coloured green when close ≥ open (up bar) and red otherwise.
 *
 * Category: Volume | Pane: Separate
 */
import { IndicatorDefinition, PlotData } from "../types/indicator.types";
import { CandleData } from "../../types/chart.types";

export const volumeIndicator: IndicatorDefinition = {
  id: "vol",
  name: "Volume",
  shortName: "Vol",
  category: "volume",
  pane: "separate",
  params: [
    { key: "upColor", label: "Up Color", type: "color", default: "#26A69A" },
    { key: "downColor", label: "Down Color", type: "color", default: "#EF5350" },
  ],
  plots: [
    { key: "volume", label: "Volume", color: "#26A69A", style: "histogram", priceScaleId: "vol" },
  ],
  calculate: (candles: CandleData[], params: Record<string, any>): PlotData[] => {
    const { upColor = "#26A69A", downColor = "#EF5350" } = params;
    const data: { time: number; value: number; color?: string }[] = [];

    for (let i = 0; i < candles.length; i++) {
      const isUp = i === 0 ? true : candles[i].close >= candles[i - 1].close;
      data.push({
        time: candles[i].time,
        value: candles[i].volume || 0,
        color: isUp ? upColor : downColor,
      });
    }

    return [{ key: "volume", data }];
  },
};
